import React from 'react';
import Card from '../../../utils/components/CardInventory/CardInventory';
import style from './PrincipalInventoryMenu.module.css';
import { useHistory } from "react-router-dom";
import { Translate } from "../../../language";
import TitleSVG from "../../../utils/components/TitleSVG/TitleSVG";
import { WineryIcon, WarehouseAdminIcon, Inventory, BatchIcon, CatalogIcon, TransferIcon, ReturnIcon } from '../../../assets/icons';

const PrincipalInventoryMenu = () => {
  const history = useHistory();

  return (
    // TodoVictor: Modificar todo lo que tenga que ver con Oil
    <div className={style.container}>
      <TitleSVG Icon={Inventory} titleHighlight={Translate('inventoryTitleHighlight', 'es')} title={Translate('inventoryTitle', 'es')} />

      <div className={style.container_options}>
        <Card
          hasOnClick={true}
          text={Translate('wineries', 'es')}
          onClick={() => { history.push('/Admin/Inventory/WineryList') }}
          Icon={WineryIcon}
        />

        <Card
          hasOnClick={true}
          text={Translate('stockAdmin', 'es')}
          onClick={() => { history.push('/Admin/Inventory/WareHouseAdmin') }}
          Icon={WarehouseAdminIcon}
        />

        <Card
          hasOnClick={true}
          text={Translate('inventories', 'es')}
          onClick={() => { history.push('/Admin/Inventory/InventoryLocationsMenu') }}
          Icon={Inventory}
        />

        <Card
          hasOnClick={true}
          text={Translate('batches', 'es')}
          onClick={() => { history.push('/Admin/Inventory/batches') }}
          Icon={BatchIcon}
        />

        <Card
          hasOnClick={true}
          text={Translate('productsCatalog', 'es')}
          onClick={() => { history.push('/Admin/Inventory/products') }}
          Icon={CatalogIcon}
        />

        <Card
          hasOnClick={true}
          text={Translate('transfers', 'es')}
          onClick={() => { history.push('/Admin/Inventory/Transfers') }}
          Icon={TransferIcon}
        />

        <Card
          hasOnClick={true}
          text={Translate('returns', 'es')}
          onClick={() => { history.push('/Admin/Inventory/Devolutions') }}
          Icon={ReturnIcon}
        />
        <Card
          text={Translate('createConsignment', 'es')}
          onClick={() => { history.push('/Admin/Inventory/CreateConsignment') }}
          Icon={ReturnIcon}
        />
   {/*      <Card
          text={'Reportes'}
          onClick={() => { history.push('/Admin/Inventory/InventorySalesReportMenu') }}
          Icon={ReturnIcon}
        /> */}
      </div>

    </div>
    
  )
}

export default PrincipalInventoryMenu